import {
  Alert,
  AlertProps,
  AlertTitle,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText
} from '@mui/material'
import { useTranslation } from 'react-i18next'
import { Valve } from '../types'
import { ConfluencePages } from '../enums'
import { useLanguage } from '../contexts/LanguageContext'
import Language from '../enums/Language'
import { useConfluencePage } from '../hooks/useConfluencePage'
import ConfluencePageArticle from './ConfluencePageArticle'
import LoadingState from './LoadingState'

export interface ValveInstallRuuviTagInstructionsProps {
  valve: Valve
}

export default function ValveInstallRuuviTagInstructions(_: ValveInstallRuuviTagInstructionsProps) {
  /**
   * The translate function.
   */
  const { t } = useTranslation('valve')

  /**
   * The language.
   */
  const { language } = useLanguage()

  /**
   * The Confluence page ID.
   */
  const pageId = initializePageId()

  /**
   * Initialize the Confluence page ID based on the current language.
   */
  function initializePageId(): string {
    switch (language) {
      case Language.FINNISH:
        return ConfluencePages.VALVE_INSTALL_RUUVITAG_INSTRUCTIONS_FI
      case Language.SWEDISH:
        return ConfluencePages.VALVE_INSTALL_RUUVITAG_INSTRUCTIONS_SE
      case Language.NORWEGIAN_BOKMÅL:
        return ConfluencePages.VALVE_INSTALL_RUUVITAG_INSTRUCTIONS_NO
      case Language.GERMAN:
        return ConfluencePages.VALVE_INSTALL_RUUVITAG_INSTRUCTIONS_DE
      case Language.SPANISH:
        return ConfluencePages.VALVE_INSTALL_RUUVITAG_INSTRUCTIONS_ES
      case Language.FRENCH:
        return ConfluencePages.VALVE_INSTALL_RUUVITAG_INSTRUCTIONS_FR
      case Language.DUTCH:
        return ConfluencePages.VALVE_INSTALL_RUUVITAG_INSTRUCTIONS_NL
      case Language.ENGLISH_US:
      default:
        return ConfluencePages.VALVE_INSTALL_RUUVITAG_INSTRUCTIONS_EN
    }
  }

  /**
   * The Confluence page.
   */
  const { page, isLoading } = useConfluencePage(pageId)

  return (
    <>
      {isLoading ? (
        <LoadingState />
      ) : page ? (
        <ConfluencePageArticle page={page} />
      ) : (
        <Alert severity="info">
          <AlertTitle sx={{ m: 0 }}>{t('ValveInstallRuuviTagInstructions.title')}</AlertTitle>

          <List>
            <ListItem sx={{ py: 0 }}>
              <ListItemAvatar sx={{ minWidth: 16 }}>1.</ListItemAvatar>
              <ListItemText primary={t('ValveInstallRuuviTagInstructions.stepOne')} />
            </ListItem>

            <ListItem sx={{ py: 0 }}>
              <ListItemAvatar sx={{ minWidth: 16 }}>2.</ListItemAvatar>
              <ListItemText primary={t('ValveInstallRuuviTagInstructions.stepTwo')} />
            </ListItem>

            <ListItem sx={{ py: 0 }}>
              <ListItemAvatar sx={{ minWidth: 16 }}>3.</ListItemAvatar>
              <ListItemText primary={t('ValveInstallRuuviTagInstructions.stepThree')} />
            </ListItem>
          </List>
        </Alert>
      )}
    </>
  )
}
